module.exports = __webpack_public_path__ + "static/media/33_tn.c2eaaf18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/33_tn.jpg
// module id = 342
// module chunks = 0